import { endpoint } from "@services/api.services";
import { METHODS } from "@services/interface.service";
import { GeneralCard, TableCard } from "@ui/internal/components/card";
import { formatDate, showToast } from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { QueryMetaData } from "@utils/interface/index.interface";
import { FormFormsData } from "@utils/interface/journey.interface";
import { useListData, usePostData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router";
import { ColumnList } from "./column";
import SourceName from "./form";
import React from "react";

export default function ManageSource() {
  const pathname = usePathname();
  const { type } = useParams();

  const { search, date } = useMetaStore();
  const [searchParams, setSearchParams] = useSearchParams();
  const { data, refetch, isPending, error } = useListData<
    QueryMetaData<
      FormFormsData,
      {
        total_count: number;
        categories: Record<string, number>;
      }
    >
  >({
    endpoint: endpoint["managesource"],
    key: `${pathname}-listing`,
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? formatDate(date.from) : "",
      created_date__lte: date.to ? formatDate(date.to) : "",
      ordering: searchParams.get("ordering") || "order",
      is_show: searchParams.get("is_show") || "",
      is_expired: searchParams.get("is_expired") || "",
    },
  });

  const columns = ColumnList({ refetch });

  // rollback page
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);

  return (
    <div>
      <>
        <TableCard
          bulkActions
          table_content={{
            mode: "default",
            type: type || "",
          }}
          isPending={isPending}
          formId={pathname}
          sortableFilter={{
            search,
            date,
            ordering: searchParams.get("ordering") || "order",
            is_show: searchParams.get("is_show") || "",
            is_expired: searchParams.get("is_expired") || "",
          }}
          columns={columns}
          endpoint={endpoint["managesource"]}
          refetch={() => {}}
          rows={data?.data.results ?? []}
          count={data?.data?.count}
          form={<SourceName />}
        />
      </>
    </div>
  );
}
